import RegistrationStatus from "./RegistrationStatus";
import {
    Box,
    Chip,
    Tooltip,
    Typography
    } from "@mui/material";
import { ContestWithId } from "../../interfaces/IContests";
import { formatDate, getContestTimingChipInfo } from "../../utils/dates";
import { EmojiEvents } from "@mui/icons-material";

interface ContestInfoProps {
  contest: ContestWithId;
}

export default function ContestInfo({ contest }: ContestInfoProps) {
  const chip = getContestTimingChipInfo(contest.startDate, contest.endDate);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {/* Nazwa turnieju + chip z dniami */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <EmojiEvents sx={{ color: "#6366f1", fontSize: 20 }} />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {contest.name}
        </Typography>
        <Tooltip title={chip.tooltip} arrow>
          <Chip
            label={chip.label}
            size="small"
            color={chip.color}
            sx={{ fontWeight: 500, height: 24, fontSize: "0.75rem" }}
          />
        </Tooltip>
      </Box>

      {/* Termin turnieju */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
          Termin:
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.8rem" }}>
          {formatDate(contest.startDate)} - {formatDate(contest.endDate)}
        </Typography>
      </Box>

      {/* Status rejestracji */}
      <RegistrationStatus contest={contest} />
    </Box>
  );
}
